import React from "react";
import configData from "../config.json";

const Footer = () => {
  const visitCount = localStorage.getItem("visitCount") || 0;

  return (
    <footer
      className="text-light pt-4 pb-3 mt-auto" style={{background: "linear-gradient(90deg, #2c3e50, #4b79a1)"}}>
      <div className="container">
        <div className="row text-center text-md-start align-items-center">
          
          {/* Left: Logo + Org */}
          <div className="col-md-4 mb-3">
            {/* <img src={`${configData.IMAGE_URL}/bseceshop.png`} height="45" alt="BSEC Logo" className="mb-2"/> */}
            <span className="fw-bold fs-5 text-white">BSEC eShop</span>
            <p className="small mb-0">
              Bangladesh Steel & Engineering Corporation
            </p>
          </div>

          {/* Middle: Info */}
          <div className="col-md-4 mb-3 text-center">
            <h6 className="fw-bold">MIS & ICT Division</h6>
            <p className="small mb-0">
              Design & Developed by BSEC Team
            </p>
          </div>

          {/* Right: Visitor Count */}
          <div className="col-md-4 mb-3 text-md-end">
            <h6 className="fw-bold">Visitor Count</h6>
            <span className="badge bg-warning text-dark fs-6">
              {visitCount}
            </span>
          </div>
        </div>

        {/* Divider */}
        <hr className="border-light my-3" />

        {/* Bottom */}
        <div className="text-center small">
          © {new Date().getFullYear()} BSEC eShop. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
